import * as React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { makeStyles, TextField, Theme } from '@bb-ui/react-library';
import { useStyles as useJobListStyles } from '../JobList';

const useStyles = makeStyles((theme: Theme) => ({
  // The floating label sits above the input, so the row needs clearance from a tab strip or page
  // header directly above it.
  row: {
    marginTop: theme.spacing(1),
  },
}));

export interface ExecutionSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  /** Distinguishes the input when more than one executions list is rendered in a page. */
  id?: string;
  /** Rendered beside the field in the same row, as the Job list places its region picker. */
  children?: React.ReactNode;
}

/**
 * The field the Job list uses: a floating-label TextField at its intrinsic width, in a controls row
 * of its own. Deliberately not the library SearchBox, which forces `fullWidth` on its input and so
 * stretches to its container — above these tables that reads as a page-wide bar.
 */
export const ExecutionSearchField: React.FC<ExecutionSearchFieldProps> = ({
  value,
  onChange,
  id = 'execution-search-field',
  children,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { controlsRow } = useJobListStyles();

  return (
    <div className={clsx(controlsRow, classes.row)} data-testid="execution-search-field">
      <TextField
        floatingLabel
        id={id}
        label={t('jobService.executionSearchLabel')}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      />
      {children}
    </div>
  );
};

export default ExecutionSearchField;
